export const MEDICAL_REASSURANCE = {
  "Pregnant": {
    textKey: "Quiz_Reassurance_Pregnant_Text",
  },
  "Lactating": {
    textKey: "Quiz_Reassurance_Lactating_Text",
  },
  "Renal-insufficiency": {
    textKey: "Quiz_Reassurance_Renal_insufficiency_Text",
  },
  "Liver-problems": {
    textKey: "Quiz_Reassurance_Liver_problems_Text",
  },
  "Anticoagulant-medication": {
    textKey: "Quiz_Reassurance_Anticoagulant_medication_Text",
  },
  "Hemochromatosis": {
    textKey: "Quiz_Reassurance_Hemochromatosis_Text",
  },
  "Hyperthyreosis": {
    textKey: "Quiz_Reassurance_Hyperthyreosis_Text",
  },
  "Hypothyreosis": {
    textKey: "Quiz_Reassurance_Hypothyreosis_Text",
  },
  "Hashimoto-Thyreoditis": {
    textKey: "Quiz_Reassurance_Hashimoto_Thyreoditis_Text",
  },
  "High-blood-pressure": {
    textKey: "Quiz_Reassurance_High_blood_pressure_Text",
  },
  "Diabetes": {
    textKey: "Quiz_Reassurance_Diabetes_Text",
  },
  "Osteoporosis": {
    textKey: "Quiz_Reassurance_Osteoporosis_Text",
  },
  "Chronic-Fatigue": {
    textKey: "Quiz_Reassurance_Chronic_Fatigue_Text",
  },
  "Histamine-Intolerance-MCAS": {
    textKey: "Quiz_Reassurance_Histamine_Intolerance_MCAS_Text",
  },
  "Other-autoimmunity": {
    textKey: "Quiz_Reassurance_Other_autoimmunity_Text",
  },
  "Bariatric-surgery": {
    textKey: "Quiz_Reassurance_Bariatric_surgery_Text",
  },
  "Renal-Insufficiency": {
    textKey: "Quiz_Reassurance_Renal_Insufficiency_Text",
  },
  "Liver-Problems": {
    textKey: "Quiz_Reassurance_Liver_Problems_Text",
  },
  "Anticoagulant-Medication": {
    textKey: "Quiz_Reassurance_Anticoagulant_Medication_Text",
  },
  "Thyroid-Problems": {
    textKey: "Quiz_Reassurance_Thyroid_Problems_Text",
  },
  "Antihypertensive-Treatment": {
    textKey: "Quiz_Reassurance_Antihypertensive_Treatment_Text",
  },
  "Ulcera": {
    textKey: "Quiz_Reassurance_Ulcera_Text",
  },
  "Heart-Problems": {
    textKey: "Quiz_Reassurance_Heart_Problems_Text",
  },
  "Antidepressant": {
    textKey: "Quiz_Reassurance_Antidepressant_Text",
  },
  "Hormonal-Treatment": {
    textKey: "Quiz_Reassurance_Hormonal_Treatment_Text",
  },
  "Antidepressants": {
    textKey: "Quiz_Reassurance_Antidepressants_Text",
  },
  "Statins": {
    textKey: "Quiz_Reassurance_Statins_Text",
  },
  "Metformin": {
    textKey: "Quiz_Reassurance_Metformin_Text",
  },
  "Cortisone": {
    textKey: "Quiz_Reassurance_Cortisone_Text",
  },
  "PPI": {
    textKey: "Quiz_Reassurance_PPI_Text",
  },
  "Birth control pill": {
    textKey: "Quiz_Reassurance_Birth_control_pill_Text",
  },
  "Contraceptive-spiral": {
    textKey: "Quiz_Reassurance_Contraceptive_spiral_Text",
  },
  "PCOS": {
    textKey: "Quiz_Reassurance_PCOS_Text",
  },
  "Thyroid Hormones": {
    textKey: "Quiz_Reassurance_Thyroid_Hormones_Text",
  },
};

export const CONDITIONS_SLIDE_CODE = 54;
export const MEDICATIONS_SLIDE_CODE = 57;
